import { EntityAdapter, EntityState, createEntityAdapter } from '@ngrx/entity';
import { createReducer, on } from '@ngrx/store';
import { AppExceptionModel } from '../../models/app-exception.model';

import { Lesson } from '../../models/lesson.school.model';
import * as lessonActions from '../actions/lesson.school.actions';

export interface LessonState extends EntityState<Lesson> {
  loading: boolean;
  loaded: boolean;
  inProgress: boolean;
  lessonStatsLoading: boolean;
  error: AppExceptionModel | undefined;
}

export const LessonAdapter: EntityAdapter<Lesson> =
  createEntityAdapter<Lesson>();

export const initialState: LessonState = LessonAdapter.getInitialState({
  loading: false,
  loaded: false,
  inProgress: false,
  lessonStatsLoading: false,
  error: undefined,
});

export const schoolLessonReducer = createReducer(
  initialState,
  on(lessonActions.getLessons, (state, {}) => ({
    ...state,
    loading: true,
    loaded: false,
    error: undefined,
  })),
  on(lessonActions.getLesson, (state, {}) => ({
    ...state,
    error: undefined,
  })),
  on(lessonActions.addLessonToStore, (state, { lesson }) =>
    LessonAdapter.upsertOne(lesson, {
      ...state,
      error: undefined,
      loading: false,
      loaded: true,
    }),
  ),
  on(lessonActions.addLessonsToStore, (state, { lessons }) => {
    return LessonAdapter.upsertMany(lessons, {
      ...state,
      loading: false,
      loaded: true,
      inProgress: false,
      error: undefined,
    });
  }),
  on(lessonActions.getLessonsFailure, (state, { error }) => ({
    ...state,
    loading: false,
    loaded: true,
    error: error,
  })),
  on(lessonActions.getLessonFailure, (state, { error }) => ({
    ...state,
    loading: false,
    loaded: true,
    error: error,
  })),
  on(lessonActions.create, (state, { lesson }) => ({
    ...state,
    error: undefined,
    inProgress: true,
  })),
  on(lessonActions.createSuccess, (state, { lesson }) =>
    LessonAdapter.upsertOne(lesson, {
      ...state,
      error: undefined,
      inProgress: false,
    }),
  ),
  on(lessonActions.createFailure, (state, { error }) => ({
    ...state,
    error: error,
    inProgress: false,
  })),
  on(lessonActions.update, (state, { lesson }) => ({
    ...state,
    error: undefined,
    inProgress: true,
  })),
  on(lessonActions.updateSuccess, (state, { lesson }) =>
    LessonAdapter.upsertOne(lesson, {
      ...state,
      error: undefined,
      inProgress: false,
    }),
  ),
  on(lessonActions.updateFailure, (state, { error }) => ({
    ...state,
    error: error,
    inProgress: false,
  })),
  // on(lessonActions.updateNotes, (state) => ({
  //   ...state,
  //   error: undefined,
  //   inProgress: true,
  // })),
  on(lessonActions.updateNotesSuccess, (state, { lesson }) =>
    LessonAdapter.upsertOne(lesson, {
      ...state,
      error: undefined,
      inProgress: false,
    }),
  ),
  on(lessonActions.updateNotesFailure, (state, { error }) => ({
    ...state,
    error: error,
    inProgress: false,
  })),
  on(lessonActions.deleteAction, (state, { id }) => ({
    ...state,
    error: undefined,
    inProgress: true,
  })),
  on(lessonActions.deleteSuccess, (state, { id }) =>
    LessonAdapter.removeOne(id, {
      ...state,
      error: undefined,
      inProgress: false,
    }),
  ),
  on(lessonActions.deleteFailure, (state, { error }) => ({
    ...state,
    error: error,
    inProgress: false,
  })),
  // on(lessonActions.clearByAcademicYear, (state, { groupId, academicYear }) =>
  //   LessonAdapter.removeMany(id, {
  //     ...state,
  //     error: undefined,
  //     inProgress: false,
  //   })),
  on(lessonActions.clear, (state) => initialState),
);
